import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { CitiesFetchRequest, PayableChargeReduxTypes, CreatePayableChargeRequest, FetchPayableChargeByIdRequest, UpdatePayableChargeRequest, CancelPayableChargeSaga } from "./types";
import {
  approvePayableChargeApi,
  blockPayableChargeApi,
  createPayableChargeApi,
  fetchPayableChargesApi,
  fetchPayableChargeApi,
  fetchPayableChargeVersionApi,
  rejectPayableChargeApi,
  updatePayableChargeApi,
  freezePayableChargeApi,
  unFreezePayableChargeApi,
  fetchPayableChargeVersionDetailsApi,
  fetchPayableChargeLatestVersionApi,
  deletePayableChargeApi,
  cancelPayableChargeApi
} from "./api";

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* fetchCities({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchPayableChargesApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchPayableChargeByID({ payload, type }: FetchPayableChargeByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchPayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* createPayableCharge({ payload, type }: CreatePayableChargeRequest): SagaIterator {
  try {
    const response = yield call(createPayableChargeApi, payload);

    yield put({
      type: PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* updatePayableCharge({ payload, type }: UpdatePayableChargeRequest): SagaIterator {
  try {
    const response = yield call(updatePayableChargeApi, payload);

    yield put({
      type: PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}


function* deletePayableCharge({ payload, type }: UpdatePayableChargeRequest): SagaIterator {
  try {
    const response = yield call(deletePayableChargeApi, payload);

    yield put({
      type: PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}


function* fetchPayableChargesVersion({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchPayableChargeVersionApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchPayableChargesVersionDetails({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchPayableChargeVersionDetailsApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_ERROR,
      payload: { error: error }
    });
  }
}


function* fetchPayableChargesLatestVersion({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchPayableChargeLatestVersionApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_ERROR,
      payload: { error: error }
    });
  }
}

function* approvePayableCharge({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(approvePayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* rejectPayableCharges({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(rejectPayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* blockPayableCharge({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(blockPayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* freezePayableCharge({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(freezePayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* unFreezePayableCharge({ payload, type }: CitiesFetchRequest): SagaIterator {
  try {
    const response = yield call(unFreezePayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    // yield put(CurrencyApiResponseError(CurrencyReduxTypes.FETCH_FINANCIER_USERS, error));
    yield put({
      type: PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

function* cancelPayableCharge({ payload, type }: CancelPayableChargeSaga): SagaIterator {
  try {
    const response = yield call(cancelPayableChargeApi, payload);
    yield put({
      type: PayableChargeReduxTypes.CANCEL_PAYABLE_CHARGE_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: PayableChargeReduxTypes.CANCEL_PAYABLE_CHARGE_ERROR,
      payload: { error: error }
    });
  }
}

export function* watchFetchCities() {
  yield takeEvery(PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES, fetchCities);
}
export function* watchCreatePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE, createPayableCharge);
}
export function* watchFetchPayableChargeById() {
  yield takeEvery(PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE, fetchPayableChargeByID);
}
export function* watchUpdatePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE, updatePayableCharge);
}
export function* watchVerisonPayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION, fetchPayableChargesVersion);
}
export function* watchApprovePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE, approvePayableCharge);
}
export function* watchRejectPayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE, rejectPayableCharges);
}

export function* watchBlockPayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE, blockPayableCharge);
}

export function* watchFreezePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE, freezePayableCharge);
}

export function* watchUnFreezePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE, unFreezePayableCharge);
}

export function* watchFetchPayableChargesVersionDetails() {
  yield takeEvery(PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS, fetchPayableChargesVersionDetails);
}


export function* watchFetchPayableChargesLatestVersion() {
  yield takeEvery(PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION, fetchPayableChargesLatestVersion);
}

export function* watchDeletePayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE, deletePayableCharge);
}

export function* watchCancelPayableCharge() {
  yield takeEvery(PayableChargeReduxTypes.CANCEL_PAYABLE_CHARGE, cancelPayableCharge);
}




function* payableChargeSaga() {
  yield all([
    fork(watchFetchCities),
    fork(watchCreatePayableCharge),
    fork(watchFetchPayableChargeById),
    fork(watchUpdatePayableCharge),
    fork(watchVerisonPayableCharge),
    fork(watchApprovePayableCharge),
    fork(watchRejectPayableCharge),
    fork(watchBlockPayableCharge),
    fork(watchFreezePayableCharge),
    fork(watchUnFreezePayableCharge),
    fork(watchFetchPayableChargesVersionDetails),
    fork(watchFetchPayableChargesLatestVersion),
    fork(watchDeletePayableCharge),
    fork(watchCancelPayableCharge)
  ]);
}

export default payableChargeSaga;
